<header id="top"  class="clearfix header-brand">
  <div class="brand float-left">
      <p class=" mb-0">
          <img src="assets/image/cr-logo.svg" alt="">
          <!--<small>Built exclusively for the Military</small>-->
        </p>
          
  </div>
  <div *ngIf="!_parent.model.uuid" class="float-right have-account">
    <a href="javascript:void(0)" (click)="loginsubmit()">Log In</a>
  </div>
  <div *ngIf="_parent.model.uuid" class="float-right have-account">
    Welcome {{ _parent.model.first_name }}
  </div>
  </header>


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/header/header.component.html